import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="active(/:orderingId)"
    getComponent={(Location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Orders/screens/Active/router.js
 **/